'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const URL = {};

URL.querystring = function (href) {
  const queryIndex = href.indexOf('?');
  return href.substr(queryIndex + 1);
};

exports.default = URL;
